import { Flex, Input } from 'antd'
import React from 'react'
const AopsLevelStepInput = ({
  stepNumber = 1,
  value = '',
  onChange,
  placeholder = '단계 이름을 입력해주세요',
  readOnly = false,
}) => {
  return (
    <Flex align="center" gap={8}>
      <div
        style={{
          width: '28px',
          height: '24px',
          borderRadius: '100px',
          background: '#383E44',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          fontWeight: '500',
          color: '#fff',
        }}
      >
        <span>{stepNumber}</span>
      </div>
      <p
        style={{
          width: '60px',
          fontSize: '16px',
          fontWeight: '500',
          color: '#383E44',
        }}
      >
        {stepNumber}단계
      </p>
      <Input
        placeholder={placeholder || '단계 이름을 입력해주세요'}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        readOnly={readOnly}
        style={{
          width: '100%',
          height: '52px',
          borderRadius: '8px',
          border: '1px solid #E2EAEF',
          background: readOnly ? '#F9FAFB' : '#fff',
        }}
      />
    </Flex>
  )
}

export default AopsLevelStepInput
